export const PROGRESS_OUTCOMES = ['correct', 'incorrect', 'review', 'reviewed'];
export const isAttemptedOutcome = outcome => PROGRESS_OUTCOMES.includes(outcome);
export function attemptedQuestion(progress, id) {
    return isAttemptedOutcome(progress?.results?.[id]?.outcome) || (Array.isArray(progress?.completedQuestions) && progress.completedQuestions.includes(id));
}
export function progressSaveMessage(error) {
    if (error?.code === 'permission-denied') return 'Your account could not save this progress update. Your answer is kept here. Ask your administrator to check tracker access, then retry.';
    return error?.message?.includes('daily plan changed') ? error.message : 'Your answer was checked, but progress could not be saved. Check your connection and retry before leaving.';
}
